var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"wrap",staticClass:"b-step-indicator"},[_vm._l((_vm.steps),function(step,index){return _c('div',{key:index,ref:"barEl",refInFor:true,class:["b-step-indicator-bar", { active: index <= _vm.currentIndex }]})}),_c('div',{staticClass:"b-step-indicator-cursor",style:(_vm.cursorStyle)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }